export default __webpack_public_path__ + "static/eye_animation-f702c4865485ef40bbd3033507204f1b.mp4";